module.exports = __webpack_public_path__ + "media/pagination.aea0ed98.mp4";